export default __webpack_public_path__ + "69063c65536c9dedd2e7cc8cefc272a3.svg";